import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { BASE } from '../utils/api'

export function ResetPasswordPage() {
  const navigate = useNavigate()
  const [token, setToken] = useState<string | null>(null)
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [showPass, setShowPass] = useState(false)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [done, setDone] = useState(false)

  useEffect(() => {
    document.documentElement.classList.remove('dark')
    document.body.style.overflow = 'auto'
    document.body.style.height = 'auto'
    const t = new URLSearchParams(window.location.search).get('token')
    setToken(t)
    return () => {
      document.body.style.overflow = ''
      document.body.style.height = ''
    }
  }, [])

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    if (password.length < 8) {
      setError('Пароль должен содержать минимум 8 символов')
      return
    }
    if (password !== confirm) {
      setError('Пароли не совпадают')
      return
    }
    setLoading(true)
    setError('')
    try {
      const res = await fetch(`${BASE}/auth/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, newPassword: password }),
      })
      if (!res.ok && res.status !== 204) {
        const ct = res.headers.get('content-type') ?? ''
        if (ct.includes('application/json')) {
          const data = await res.json() as { message?: string }
          throw new Error(data.message ?? 'Ошибка. Попробуйте ещё раз.')
        }
        throw new Error('Сервер недоступен. Попробуйте позже.')
      }
      setDone(true)
    } catch (err) {
      setError((err as Error).message)
    } finally {
      setLoading(false)
    }
  }

  const inputStyle = (hasError: boolean): React.CSSProperties => ({
    width: '100%',
    padding: '11px 14px',
    background: '#f5f5f5',
    border: `1px solid ${hasError ? '#ef4444' : '#e0e0e0'}`,
    borderRadius: '10px',
    color: '#1a1a1a',
    fontSize: '14px',
    outline: 'none',
    boxSizing: 'border-box',
    transition: 'border-color 0.15s',
  })

  return (
    <div style={{
      minHeight: '100vh',
      background: '#f5f5f5',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '24px',
      fontFamily: "'Inter', 'Segoe UI', system-ui, sans-serif",
    }}>
      <div style={{ position: 'fixed', inset: 0, pointerEvents: 'none', overflow: 'hidden', zIndex: 0 }}>
        <div style={{
          position: 'absolute', top: '30%', left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '600px', height: '400px',
          background: 'radial-gradient(ellipse, rgba(91,106,240,0.08) 0%, transparent 70%)',
          borderRadius: '50%',
        }} />
      </div>

      <div style={{
        position: 'relative', zIndex: 1,
        width: '100%', maxWidth: '400px',
        background: '#ffffff',
        border: '1px solid #e0e0e0',
        borderRadius: '20px',
        padding: '40px',
        boxShadow: '0 8px 40px rgba(0,0,0,0.08)',
      }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: '28px' }}>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
            <div style={{
              width: '36px', height: '36px', borderRadius: '10px',
              background: '#5b6af0',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontWeight: 900, color: '#fff', fontSize: '16px',
              boxShadow: '0 4px 16px rgba(91,106,240,0.25)',
            }}>B</div>
            <span style={{ fontWeight: 900, fontSize: '24px', color: '#1a1a1a', letterSpacing: '-0.5px' }}>BST</span>
          </div>
          <div style={{ fontSize: '14px', color: '#9b9b9b', marginTop: '4px' }}>Новый пароль</div>
        </div>

        {/* Нет токена */}
        {!token && (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '36px', marginBottom: '12px' }}>🔗</div>
            <p style={{ margin: '0 0 20px', color: '#666', fontSize: '14px', lineHeight: 1.6 }}>
              Ссылка недействительна или устарела.<br />Запросите новую ссылку для сброса пароля.
            </p>
            <button
              onClick={() => navigate('/login')}
              style={{
                padding: '12px 24px', background: '#5b6af0', color: '#fff',
                border: 'none', borderRadius: '10px', fontSize: '14px', fontWeight: 700,
                cursor: 'pointer', boxShadow: '0 4px 20px rgba(91,106,240,0.25)',
              }}
            >
              На страницу входа
            </button>
          </div>
        )}

        {/* Успешно */}
        {token && done && (
          <div style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <div style={{ fontSize: '40px' }}>✅</div>
            <h3 style={{ margin: 0, fontSize: '18px', fontWeight: 800, color: '#1a1a1a' }}>Пароль изменён!</h3>
            <p style={{ margin: 0, fontSize: '14px', color: '#666', lineHeight: 1.6 }}>
              Теперь вы можете войти в аккаунт с новым паролем.
            </p>
            <button
              onClick={() => navigate('/login')}
              style={{
                marginTop: '8px', padding: '13px',
                background: '#5b6af0', color: '#fff', border: 'none', borderRadius: '10px',
                fontSize: '14px', fontWeight: 700, cursor: 'pointer',
                boxShadow: '0 4px 20px rgba(91,106,240,0.25)',
              }}
            >
              Войти в кабинет
            </button>
          </div>
        )}

        {/* Форма */}
        {token && !done && (
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
            <div>
              <label style={{ display: 'block', fontSize: '12px', fontWeight: 600, color: '#6b6b6b', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '6px' }}>
                Новый пароль <span style={{ fontWeight: 400, textTransform: 'none' }}>(мин. 8 символов)</span>
              </label>
              <div style={{ position: 'relative' }}>
                <input
                  type={showPass ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => { setPassword(e.target.value); setError('') }}
                  placeholder="Придумайте новый пароль"
                  autoComplete="new-password"
                  autoFocus
                  style={{ ...inputStyle(!!error), paddingRight: '40px' }}
                  onFocus={(e) => { e.target.style.borderColor = '#5b6af0' }}
                  onBlur={(e) => { e.target.style.borderColor = error ? '#ef4444' : '#e0e0e0' }}
                />
                <button
                  type="button"
                  onClick={() => setShowPass(!showPass)}
                  style={{
                    position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)',
                    background: 'none', border: 'none', cursor: 'pointer',
                    color: '#9b9b9b', fontSize: '14px', padding: '2px',
                  }}
                >
                  {showPass ? '🙈' : '👁'}
                </button>
              </div>
            </div>

            <div>
              <label style={{ display: 'block', fontSize: '12px', fontWeight: 600, color: '#6b6b6b', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '6px' }}>
                Повторите пароль
              </label>
              <input
                type={showPass ? 'text' : 'password'}
                value={confirm}
                onChange={(e) => { setConfirm(e.target.value); setError('') }}
                placeholder="Повторите пароль"
                autoComplete="new-password"
                style={inputStyle(!!error && password !== confirm)}
                onFocus={(e) => { e.target.style.borderColor = '#5b6af0' }}
                onBlur={(e) => { e.target.style.borderColor = (error && password !== confirm) ? '#ef4444' : '#e0e0e0' }}
              />
            </div>

            {error && (
              <div style={{
                padding: '10px 14px',
                background: 'rgba(239,68,68,0.06)',
                border: '1px solid rgba(239,68,68,0.2)',
                borderRadius: '8px',
                fontSize: '13px', color: '#dc2626',
              }}>
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              style={{
                marginTop: '4px', padding: '13px',
                background: loading ? '#3a4ab0' : '#5b6af0',
                color: '#fff', border: 'none', borderRadius: '10px',
                fontSize: '14px', fontWeight: 700,
                cursor: loading ? 'not-allowed' : 'pointer',
                boxShadow: '0 4px 20px rgba(91,106,240,0.25)',
                transition: 'all 0.15s',
                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
              }}
            >
              {loading ? (
                <>
                  <span style={{ display: 'inline-block', width: '14px', height: '14px', border: '2px solid rgba(255,255,255,0.3)', borderTopColor: '#fff', borderRadius: '50%', animation: 'spin 0.7s linear infinite' }} />
                  Сохранение...
                </>
              ) : 'Сохранить новый пароль'}
            </button>

            <button
              type="button"
              onClick={() => navigate('/login')}
              style={{ background: 'none', border: 'none', color: '#9b9b9b', fontSize: '13px', cursor: 'pointer', padding: '4px 0' }}
            >
              ← Назад ко входу
            </button>
          </form>
        )}
      </div>

      <div style={{ position: 'relative', zIndex: 1, marginTop: '24px', fontSize: '12px', color: '#9b9b9b', textAlign: 'center' }}>
        © {new Date().getFullYear()} BST · Конструктор сайтов нового поколения
      </div>

      <style>{`
        @keyframes spin { to { transform: rotate(360deg); } }
        input::placeholder { color: #9b9b9b; }
      `}</style>
    </div>
  )
}
